module.exports = __webpack_public_path__ + "static/media/Background.a871ad7f.png";